// Theme-aware colors for recharts (which need explicit hex/hsl, not CSS classes).
export const CRIMSON = "#A5122F";
export const CRIMSON_DARK = "#B71338";

export function chartColors(theme) {
  const dark = theme === "dark";
  return {
    primary: dark ? CRIMSON_DARK : CRIMSON,
    won: dark ? "#34d399" : "#059669",
    created: dark ? "#94a3b8" : "#64748b",
    grid: dark ? "#1e293b" : "#e2e8f0",
    axis: dark ? "#94a3b8" : "#64748b",
    aging: {
      "0-30": dark ? "#34d399" : "#059669",
      "31-60": dark ? "#fbbf24" : "#d97706",
      "61-90": dark ? "#fb923c" : "#ea580c",
      "90+": dark ? "#B71338" : "#A5122F",
    },
  };
}
